const NC_ORIGIN_OPTIONS = [
  { id: 0, name: 'Resultado RIPD', value: 'ripd_result' },
  { id: 1, name: 'Incidente', value: 'incident' },
  { id: 2, name: 'Auditoria Interna', value: 'internal_audit' },
  { id: 3, name: 'Auditoria Externa', value: 'external_audit' },
  { id: 4, name: 'Atendimento ao Titular', value: 'holder_service' },
  { id: 5, name: 'Outro', value: 'other' },
]

const NC_ORIGINS = {
  ripd_result: 'RESULTADO RIPD',
  incident: 'INCIDENTE',
  internal_audit: 'AUDITORIA INTERNA',
  external_audit: 'AUDITORIA EXTERNA',
  holder_service: 'ATENDIMENTO AO TITULAR',
  other: 'OUTRO',
}

const CLASSIFICATION_OPTIONS = [
  { id: 0, name: 'Maior', value: 'major' },
  { id: 1, name: 'Menor', value: 'minor' },
  { id: 2, name: 'Observação', value: 'observation' },
]

const CLASSIFICATIONS = {
  major: 'MAIOR',
  minor: 'MENOR',
  observation: 'OBSERVAÇÃO',
}

const PRIORITY_OPTIONS = [
  { id: 0, name: 'Baixa', value: 'low' },
  { id: 1, name: 'Média', value: 'medium' },
  { id: 2, name: 'Alta', value: 'high' },
  { id: 3, name: 'Crítica', value: 'critical' },
]

const PRIORITIES = {
  low: 'BAIXA',
  medium: 'MÉDIA',
  high: 'ALTA',
  critical: 'CRÍTICA',
}

const STATUS_OPTIONS = [
  { id: 0, name: 'Aberta', value: 'open' },
  { id: 1, name: 'Em Análise', value: 'in_analysis' },
  { id: 2, name: 'Fechada', value: 'closed' },
]

const STATUSES = {
  open: 'ABERTA',
  in_analysis: 'EM ANÁLISE',
  closed: 'FECHADA',
}

const EFFECTIVENESS_PROVEN_OPTIONS = [
  { id: 0, name: 'Sim', value: true },
  { id: 1, name: 'Não', value: false },
]

export default {
  CLASSIFICATION_OPTIONS,
  CLASSIFICATIONS,
  EFFECTIVENESS_PROVEN_OPTIONS,
  NC_ORIGIN_OPTIONS,
  NC_ORIGINS,
  PRIORITIES,
  PRIORITY_OPTIONS,
  STATUS_OPTIONS,
  STATUSES,
}
